module.exports = __webpack_public_path__ + "static/media/lightbulbs.875fc4b4.png";